import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	paper: {
		width: 'min(92vw, 420px)',
	},
	root: {
		padding: '14px',
		gap: '12px',
	},
	header: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		gap: '8px',
	},
	title: {
		fontSize: '15px',
		fontWeight: 700,
	},
	subtitle: {
		fontSize: '12px',
		color: 'text.secondary',
	},
	incident: {
		textTransform: 'none',
		borderRadius: '8px',
	},
	photo: {
		borderRadius: '10px',
		overflow: 'hidden',
		border: '1px solid',
		borderColor: 'divider',
	},
	image: {
		display: 'block',
		width: '100%',
		height: 'auto',
		backgroundColor: '#000',
		cursor: 'zoom-in',
	},
	viewerPaper: {
		margin: '16px',
		maxWidth: 'calc(100vw - 32px)',
		maxHeight: 'calc(100vh - 32px)',
		borderRadius: '12px',
		overflow: 'hidden',
		backgroundColor: '#000',
	},
	viewerStage: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: '#000',
	},
	viewerImage: {
		display: 'block',
		height: 'calc(100vh - 32px - 44px)',
		width: 'auto',
		maxWidth: 'calc(100vw - 32px)',
		objectFit: 'contain',
	},
	viewerNav: {
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
		color: '#fff',
		backgroundColor: 'rgba(0, 0, 0, 0.45)',
		'&:hover': {backgroundColor: 'rgba(0, 0, 0, 0.7)'},
	},
	viewerClose: {
		position: 'absolute',
		top: 8,
		right: 8,
		color: '#fff',
		backgroundColor: 'rgba(0, 0, 0, 0.45)',
		'&:hover': {backgroundColor: 'rgba(0, 0, 0, 0.7)'},
	},
	viewerCaption: {
		display: 'flex',
		alignItems: 'center',
		gap: '14px',
		padding: '10px 14px',
		minHeight: '44px',
		backgroundColor: 'background.paper',
		fontSize: '14px',
	},
	caption: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: '6px 10px',
		fontSize: '12px',
	},
} as const satisfies SxType
